import { type Config, driver } from 'driver.js'

import { getTourOverlayConfig } from './get-tour-overlay-config'

export const createOnboardingTourDriver = (config: Config) =>
  driver({
    allowClose: false,
    popoverClass: 'onboarding-tour-popover',
    ...getTourOverlayConfig(),
    ...config,
  })
